<template>
  <div class="page">
    <!-- 头部 -->
    <div class="header">
      <div class="logo-container">
        <img class="logo" src="./assets/img/logo.png" alt="公学芸自动异地改定位打卡签到日周月报模板撰写生成助手" />
      </div>
      <h1 class="title">论文生成</h1>
      <p class="subtitle">无视知网、万方、维普所有查重</p>
    </div>

    <!-- 主要内容 -->
    <div class="content">
      <!-- 输入表单卡片 -->
      <div class="form-card">
        <div class="form-item">
          <label class="form-label">标题</label>
          <van-field
            v-model="paperTitle"
            placeholder="请输入论文标题"
            maxlength="100"
            show-word-limit
            class="title-input"
          />
        </div>

        <div class="button-container">
          <van-button 
            type="primary"
            size="large"
            block
            round
            :loading="isGenerating"
            :disabled="!paperTitle"
            @click="generateOutline"
            class="action-btn primary-btn"
          >
            {{ isGenerating ? '生成中...' : '生成大纲' }}
          </van-button>
          
          <van-button 
            type="info"
            size="large"
            block
            round
            @click="openSampleDocument"
            class="action-btn secondary-btn"
          >
            范文样本
          </van-button>
        </div>

        <div class="notice-card">
          <van-icon name="warning-o" class="notice-icon" />
          <span class="notice-text">所有生成的论文模板只可用作格式参考，不允许抄袭、代写、直接照用等行为。</span>
        </div>
      </div>

      <!-- 大纲显示卡片 -->
      <div v-if="outline" class="result-card">
        <div class="card-header">
          <h3 class="card-title">论文大纲</h3>
        </div>
        <div class="card-content">
          <div class="outline-text">{{ outline }}</div>
        </div>
        <div class="card-actions">
          <van-button 
            type="primary" 
            size="small" 
            round
            :loading="isGeneratingContent"
            :disabled="!outline"
            @click="generateContent"
            class="action-btn-small"
          >
            {{ isGeneratingContent ? '生成中...' : '生成论文' }}
          </van-button>
        </div>
      </div>

      <!-- 生成进度卡片 -->
      <div v-if="taskId && !isCompleted" class="result-card">
        <div class="card-header">
          <h3 class="card-title">生成进度</h3>
        </div>
        <div class="card-content">
          <van-progress 
            :percentage="progress" 
            stroke-width="8" 
            color="#667eea"
            track-color="#f0f0f0"
          />
          <p class="progress-text">{{ progressText }}</p>
        </div>
      </div>

      <!-- 生成结果卡片 -->
      <div v-if="paperContent" class="result-card">
        <div class="card-header">
          <h3 class="card-title">生成结果</h3>
        </div>
        <div class="card-content">
          <div class="content-text">{{ paperContent }}</div>
        </div>
        <div class="card-actions">
          <van-button 
            type="success" 
            size="small" 
            round
            @click="downloadPaper"
            class="action-btn-small"
          >
            <van-icon name="down" />
            下载
          </van-button>
          <van-button 
            type="primary" 
            size="small" 
            round
            @click="copyContent"
            class="action-btn-small"
          >
            <van-icon name="copy" />
            复制
          </van-button>
        </div>
      </div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>

<script>
import axios from 'axios'
import BottomNavigation from '@/components/BottomNavigation.vue'
import { API_ENDPOINTS } from '@/config/api'

export default {
  components: {
    BottomNavigation
  },
  data() {
    return {
      paperTitle: '',
      outline: '',
      paperContent: '',
      taskId: '',
      isGenerating: false,
      isGeneratingContent: false,
      isCompleted: false,
      progress: 0,
      progressText: '准备中...',
      progressTimer: null
    };
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
    }
  },
  methods: {
    showToast(message) {
      this.$toast(message);
    },

    // 生成大纲
    async generateOutline() {
      if (!this.paperTitle.trim()) {
        this.showToast('请输入论文标题');
        return;
      }

      this.isGenerating = true;
      this.outline = '';

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const res = await axios.post(API_ENDPOINTS.LWB.GENERATE_PAPER_OUTLINE, {
          title: this.paperTitle
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.outline = res.data.data;
          this.showToast('大纲生成成功');
        } else {
          this.showToast(res.data.message || '大纲生成失败');
        }
      } catch (error) {
        console.error('生成大纲失败:', error);
        this.showToast('生成大纲失败，请重试');
      } finally {
        this.isGenerating = false;
      }
    },

    // 生成论文内容
    async generateContent() {
      if (!this.paperTitle.trim()) {
        this.showToast('请输入论文标题');
        return;
      }

      if (!this.outline) {
        this.showToast('请先生成大纲');
        return;
      }

      this.isGeneratingContent = true;
      this.paperContent = '';
      this.taskId = '';
      this.progress = 0;
      this.isCompleted = false;

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const res = await axios.post(API_ENDPOINTS.LWB.GENERATE_PAPER_CONTENT, {
          title: this.paperTitle,
          outline: this.outline
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.taskId = res.data.data;
          this.showToast('开始生成论文，请稍候...');
          this.startProgressCheck();
        } else {
          this.showToast(res.data.message || '生成失败');
        }
      } catch (error) {
        console.error('生成论文失败:', error);
        if (error.response && error.response.data && error.response.data.message) {
          this.showToast(error.response.data.message);
        } else {
          this.showToast('生成论文失败，请重试');
        }
      } finally {
        this.isGeneratingContent = false;
      }
    },

    // 开始检查进度
    startProgressCheck() {
      this.progressTimer = setInterval(async () => {
        await this.checkProgress();
      }, 3000); // 每3秒检查一次
    },

    // 检查生成进度
    async checkProgress() {
      if (!this.taskId) return;

      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_ENDPOINTS.LWB.GET_PAPER_PROGRESS}/${this.taskId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          const data = res.data.data;
          this.progress = data.progress || 0;
          this.progressText = data.status || '生成中...';

          if (data.completed) {
            this.isCompleted = true;
            this.paperContent = data.content;
            this.progress = 100;
            this.progressText = '生成完成';
            
            if (this.progressTimer) {
              clearInterval(this.progressTimer);
              this.progressTimer = null;
            }
            
            this.showToast('论文生成完成');
          }
        }
      } catch (error) {
        console.error('检查进度失败:', error);
      }
    },

    // 下载论文
    downloadPaper() {
      if (!this.paperContent) {
        this.showToast('没有可下载的内容');
        return;
      }

      const blob = new Blob([this.paperContent], { type: 'text/plain;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.paperTitle || '论文'}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      this.showToast('下载成功');
    },

    // 复制内容
    async copyContent() {
      if (!this.paperContent) {
        this.showToast('没有可复制的内容');
        return;
      }

      try {
        await navigator.clipboard.writeText(this.paperContent);
        this.showToast('内容已复制到剪贴板');
      } catch (error) {
        // 降级方案
        const textArea = document.createElement('textarea');
        textArea.value = this.paperContent;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.showToast('内容已复制到剪贴板');
      }
    },

    // 打开范文样本
    openSampleDocument() {
      window.open(API_ENDPOINTS.LWB.SAMPLE_DOCUMENT, '_blank');
    }
  }
};
</script>

<style scoped>
.page {
  background-color: rgba(247, 247, 247, 1);
  min-height: 100vh;
  padding-bottom: 80px;
  width: 100%;
}

/* 头部样式 */
.header {
  background-color: rgba(247, 247, 247, 1);
  padding: 0px 0px 20px;
  text-align: center;
  color: #333;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.logo-container {
  margin: 15px 0 8px 0;
  height: 125px;
}

.logo {
  width: 50px;
  height: 50px;
  border-radius: 8px;
}

.title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px 0;
  letter-spacing: 1px;
}

.subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
}

/* 内容区域 */
.content {
  padding: 16px;
  margin-top: -10px;
  position: relative;
  z-index: 1;
}

/* 表单卡片 */
.form-card {
  background: white;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.title-input {
  border-radius: 12px;
}

.title-input :deep(.van-field__control) {
  font-size: 16px;
  padding: 12px 0;
}

/* 按钮容器 */
.button-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.action-btn {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 25px !important;
}

.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.secondary-btn {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border: none;
}

/* 提示卡片 */
.notice-card {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: #fff8e1;
  border: 1px solid #ffecb3;
  border-radius: 12px;
  border-left: 4px solid #ffc107;
  width: 100%;
  box-sizing: border-box;
}

.notice-icon {
  color: #ff9800;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  font-size: 16px;
}

.notice-text {
  font-size: 12px;
  color: #e65100;
  line-height: 1.5;
  font-weight: 500;
  flex: 1;
  word-wrap: break-word;
  word-break: break-all;
}

/* 结果卡片 */
.result-card {
  background: white;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.card-content {
  padding: 16px 20px;
}

.outline-text,
.content-text {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
}

.progress-text {
  text-align: center;
  margin: 12px 0 0 0;
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

/* 卡片操作按钮 */
.card-actions {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.action-btn-small {
  flex: 1;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
}

.action-btn-small :deep(.van-icon) {
  margin-right: 4px;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .content {
    padding: 16px 12px 12px;
  }
  
  .form-card,
  .result-card {
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 20px;
  }
  
  .title {
    font-size: 22px;
  }
  
  .action-btn {
    height: 46px;
    font-size: 15px;
  }
  
  .logo {
    width: 45px;
    height: 45px;
  }
  
  .logo-container {
    margin: 12px 0 6px 0;
  }
}

/* 滚动条样式 */
.outline-text::-webkit-scrollbar,
.content-text::-webkit-scrollbar {
  width: 4px;
}

.outline-text::-webkit-scrollbar-track,
.content-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.outline-text::-webkit-scrollbar-thumb,
.content-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.outline-text::-webkit-scrollbar-thumb:hover,
.content-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
